
define('text!templates/app/zoom/zoom.html',[],function () { return '<div id="zoom-modal">\n</div>\n';});

